import React from 'react';
//need to fix content covering by mobile menu

const BottomSpace = () => {
  return <div style={{ height: 100 }}></div>;
};

export default BottomSpace;
